<div class="row">
    <div class="col-md-12">
        <div class="card card-primary mt-0">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12">
                        <app-addProduct></app-addProduct>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
